import { useState, type FormEvent } from "react";

const stats = [
  { value: "1280万+", label: "累计存档快照" },
  { value: "46万+", label: "收录追溯页面" },
  { value: "2016年", label: "最早覆盖时间" },
  { value: "99.2%", label: "快照可读率" },
];

export default function Hero() {
  const [kw, setKw] = useState("");

  const goSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const target = document.getElementById("search");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (kw.trim()) {
      window.setTimeout(() => {
        const box = document.getElementById("archive-keyword") as HTMLInputElement | null;
        box?.focus();
      }, 700);
    }
  };

  return (
    <section id="home" className="relative flex min-h-[640px] w-full items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=warm%20terracotta%20and%20coral%20abstract%20fluid%20composition%20with%20soft%20cream%20paper%20texture%2C%20gentle%20gradient%20melon%20and%20leaf%20tones%2C%20playful%20editorial%20illustration%20style%2C%20smooth%20organic%20shapes%2C%20bright%20airy%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=chigua-hero-bg-01&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-background-50/85 via-background-50/70 to-primary-500/20"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-800 ring-1 ring-accent-300/60">
          <i className="ri-history-line"></i> 网页历史快照 · 缓存版本 · 旧版存档查看
        </span>

        <h1 className="mt-6 max-w-3xl text-3xl leading-tight text-foreground-950 md:text-[44px] md:leading-[1.18]">
          吃瓜网页历史快照
          <span className="block text-primary-600">找回每一次被删改的旧版内容</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-7 text-foreground-700">
          打开吃瓜网页即可检索历史快照、缓存版本与备份存档。通过时间线留痕与并排对比，
          快速追查页面原始内容，让被删除、被修改的信息有据可查、随时可溯。
        </p>

        <form onSubmit={goSearch} className="mt-8 flex max-w-2xl flex-col gap-2 sm:flex-row sm:items-center">
          <div className="flex flex-1 items-center gap-2 rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-300/60">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="输入页面链接或关键词，检索历史快照…"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始查快照
          </button>
        </form>

        <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-primary-500"></i> 平均每 8 分钟自动抓取
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-file-copy-2-line text-primary-500"></i> 正文 / 评论 / 配图可留痕
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-lock-line text-primary-500"></i> 只读快照，原页不二次修改
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 border-t border-background-300/70 pt-6 md:grid-cols-4 md:gap-5">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="font-heading text-2xl text-primary-600 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#search"
        aria-label="向下浏览"
        className="absolute bottom-5 left-1/2 z-10 hidden -translate-x-1/2 md:flex"
      >
        <i className="ri-arrow-down-line animate-bounce text-2xl text-foreground-500"></i>
      </a>
    </section>
  );
}